import React from "react";
import "./RedifiningPLMSolutionPage.css";
import MendixOverview from "./RedifiningPLMSolutionOverview";
import BannerImage from "../../../assets/other_image/redefine_solution.jpg";
import Letsgetintouch from "../../PLMImplementation/BusinessProcessAndChangeManagement/Letsgetintouch";
import Banner from "../SolutionBanner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";

const RedifiningPLMSolutionPage = () => {
  return (
    <section className="RedifiningPLMSolution-process">
     <Banner
        image={BannerImage} // Pass the image for this page
        heading="Redefining PLM Solutions" // Pass the heading text for this page
      />
             <FloatingContactUs />

      <MendixOverview />
      <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
          <h4 className="RedifiningPLMSolution-page-heading">
            Unlock the Power :
          </h4>
          <h5 className="RedifiningPLMSolution-subheading">
            Discover the Transformative Benefits of Redefining PLM Solutions with NexTech!
          </h5>
          <ul className="custom-bullets">
            <li>Teamcenter system usage to its fullest extent </li>
            <li>
              To ensure Teamcenter system is working with optimum performance
            </li>
            <li>Redefined solutions may offer more benefits</li>
            <li>
              Infrastructure is properly evaluated for scaling and tuned
              appropriately for efficient working
            </li>
            <li>
              Ensuring benefits of Teamcenter new and enhanced functionalities
              are adding value to business at right time
            </li>
            <li>
              Cost-effective tuning mechanisms to increase the performance of
              Teamcenter infrastructure, before thinking about expensive
              infrastructure upgrade
            </li>
          </ul>
        </div>
      </section>
      <section>
        <div className="solutions container">
          <h4 className="RedifiningPLMSolution-page-heading">Our Solutions</h4>
          <ul className="custom-bullets">
            <li>Infrastructure and Environments</li>
            <li>System interface and integrations</li>
            <li>Global deployment strategy</li>
            <li>
              Hardware sizing, replication, consolidation, upgrading, and
              testing
            </li>
            <li>Security</li>
            <li>Performance & scalability</li>
            <li>System monitoring and health check</li>
          </ul>
        </div>
      </section>
      <section style={{ background: "#f5f7fa" }}>
        <div className="why-nextech container">
          <h4 className="RedifiningPLMSolution-page-heading">Why NexTech?</h4>
          <h5 className="RedifiningPLMSolution-subheading">
            For Redefining PLM Solutions:
          </h5>
          <ul className="custom-bullets">
            <li>
              Unique methodology addressing challenges: Our methodology
              effectively tackles data integration, architecture changes,
              capability mapping, and existing issues to ensure optimal
              alignment with Teamcenter infrastructure and solutions.
            </li>
            <li>
              Cost-effective approach: We offer cost-effective tuning mechanisms
              to enhance Teamcenter performance without the need for expensive
              infrastructure upgrades, ensuring maximum ROI.
            </li>
            <li>
              Comprehensive offerings: From infrastructure evaluation and system
              interface integrations to global deployment strategies and
              security enhancements, we provide a holistic solution for PLM
              redefinition.
            </li>
            <li>
              Expertise in system analysis and redefinition: Our team conducts
              in-depth analysis of existing environments and utilizes a
              structured process to redefine infrastructure, system
              integrations, security, and solutions.
            </li>
            <li>
              Focus on business value: Our approach prioritizes achieving
              business goals, optimizing performance, ensuring system
              interoperability, and enhancing ROI, ultimately delivering
              tangible benefits to your organization.
            </li>
          </ul>
        </div>
      </section>
      <section>
        <div className="solutions container">
          <h4 className="RedifiningPLMSolution-page-heading">
            Process of Redefining
          </h4>
          <ul className="custom-bullets">
            <li>
              Perform Analysis of the existing Teamcenter environment by
              reviewing hardware, network, software, configuration, performance,
              third party apps, Use Cases, and data sets.
            </li>
            <li>
              Report on redefinition requirement at various system architecture
              element
            </li>
            <li>
              Redefine global deployment to align with business, IT, Security,
              Performance and Usability requirements{" "}
            </li>
            <li>
              Redefine infrastructure as per the business need while ensuring
              system interoperability and version compatibility{" "}
            </li>
            <li>
              Redefine the system integration from old way to possible new way{" "}
            </li>
            <li>
              Redefine security at metadata and data files levels as per the
              business need like compliance, ITAR, ADA.{" "}
            </li>
            <li>
              Redefine Teamcenter solutions as per the business requirement
              while ensuring best use of new/enhanced functionality offered by
              Teamcenter.
            </li>
            <li>Enable ROI improvement</li>
          </ul>
        </div>
      </section>
      <Letsgetintouch />
    </section>
  );
};

export default RedifiningPLMSolutionPage;
